import { deleteRequest, get, post, put } from 'helpers/api';
import { serverErrors } from 'helpers/api_errors';
import { getPlaybookTasksForTarget, getPlaybookType, isDealPlaybook } from 'bundles/apex/playbooks/config/helpers';

export const SET_PLAYBOOKS = 'SET_PLAYBOOKS';
export function loadPlaybooks() {
  return async (dispatch, getState) => {
    const playbooks = await get(getState().paths[`${getState().playbookRecordType}PlaybookIndex`]);
    dispatch({ type: SET_PLAYBOOKS, playbooks });
  };
}

export const ADD_FIELD = 'ADD_FIELD';
export function createField(playbook, name, stage, required) {
  return async (dispatch) => {
    const field = await post(playbook.fieldsPath, { name, stage, required });
    dispatch(({ type: ADD_FIELD, playbook, field }));
  };
}

export const CHANGE_FIELD = 'CHANGE_FIELD';
export function changeField(playbook, field, changes) {
  return (dispatch) => {
    put(field.path, changes);
    dispatch({ type: CHANGE_FIELD, playbook, field, changes });
  };
}

export const DELETE_FIELD = 'DELETE_FIELD';
export function deleteField(playbook, field) {
  return (dispatch) => {
    deleteRequest(field.path);
    dispatch({ type: DELETE_FIELD, playbook, field });
  };
}

export const ADD_TASK = 'ADD_TASK';
export function createTask(playbook, newTask) {
  return async (dispatch, getState) => {
    const currentPlaybook = getState().playbooks.find(statePlaybook => statePlaybook.id === playbook.id);

    const tasks = getPlaybookTasksForTarget(currentPlaybook, newTask);
    const sortOrder = tasks.length === 0
      ? 0
      : Math.max(...tasks.map(task => task.sortOrder)) + 1;
    const task = await post(playbook.tasksPath, {
      ...newTask,
      sortOrder,
    });

    dispatch(({ type: ADD_TASK, playbook, task }));
  };
}

export const CHANGE_TASK = 'CHANGE_TASK';
export function changeTask(playbook, task, changes) {
  return { type: CHANGE_TASK, playbook, task, changes };
}

export const REPLACE_TASK = 'REPLACE_TASK';
export function updateTask(playbook, task, changes) {
  return async (dispatch) => {
    const updatedTask = await put(task.path, changes);
    dispatch({ type: REPLACE_TASK, playbook, task, updatedTask });
  };
}

export const DELETE_TASK = 'DELETE_TASK';
export function deleteTask(playbook, task) {
  return (dispatch) => {
    deleteRequest(task.path);
    dispatch({ type: DELETE_TASK, playbook, task });
  };
}

export const REORDER_TASKS = 'REORDER_TASKS';
export function reorderTasks(playbook, sourceTaskId, targetTask) {
  return { type: REORDER_TASKS, playbook, sourceTaskId, targetTask };
}

export function saveTaskOrdering(playbook, targetTask) {
  return async (dispatch, getState) => {
    playbook = getState().playbooks.find(statePlaybook => statePlaybook.id === playbook.id);

    const body = { tasks: [] };
    for (const [sortOrder, task] of getPlaybookTasksForTarget(playbook, targetTask).entries()) {
      const changes = { sortOrder };
      body.tasks.push({ id: task.id, ...changes });
      dispatch(changeTask(playbook, task, changes));
    }

    put(playbook.tasksPath, body);
  };
}

export function copyTasks(tasks, playbookType, target, createTasks) {
  return async (dispatch, getState) => {
    const playbook = getState().playbooks.find(playbook => (
      getPlaybookType(playbook) === playbookType
    ));

    const errors = [];
    for (const task of tasks) {
      try {
        const newTask = {
          ...task,
          assigneeId: task.assignee?.id,
          assignee: undefined,
          createTasks,
        };

        if (isDealPlaybook(playbook)) {
          newTask.stage = target;
        } else {
          newTask.status = target;
        }

        await dispatch(createTask(playbook, newTask));
      } catch (error) {
        // `helpers/api` throws the server's error messages (an array) on a validation
        // failure; include them after a line naming the task that couldn't be copied. A
        // non-array throw (e.g. a 500) has no useful message, so just the naming line shows.
        errors.push(`Could not copy "${task.name}".`, ...serverErrors(error));
      }
    }
    
    if (errors.length) {
      throw errors;
    }
  };
}
